import { decodeToken } from "react-jwt";

function getUsernameFromToken() {
  const idToken = localStorage.getItem("msal.idtoken");
  if (idToken) {
    const decodedToken = decodeToken(idToken);
    return decodedToken?.given_name || null;
  }
  console.error("Error: ID token not found in localStorage.");
  return null;
}

export default getUsernameFromToken;